
import { PAGE_TYPE, QUERY_HOMEPAGE } from "./-index.query";
import { seoMixin, pageMixin, siteNavigationSchemaMixin } from "~/mixins";
import { getHomepageOrganizationScript } from "~/utils/organization-schema";

const UID = "home-page";

export default {
  mixins: [seoMixin, pageMixin, siteNavigationSchemaMixin],

  async asyncData({ app, error }) {
    const { [PAGE_TYPE]: data } = await app.$prismicGql.request({
      query: QUERY_HOMEPAGE,
      variables: { uid: UID, lazy: false },
    });

    if (data?.slices == null || data?.slices?.length === 0) {
      return error({
        statusCode: 404,
        message: "Home page not found in the app",
      });
    }

    return {
      uid: UID,
      pageType: PAGE_TYPE,
      isCustomType: false,
      slices: data.slices,
      title: data.title,
      metaTitle: data.metaTitle,
      metaDescription: data.metaDescription,
      metaRobots: data.metaRobots,
    };
  },

  computed: {
    // Same mega menu source as SiteHeader (Vuex); layoutHeader is not provided by the layout.
    navigationItems() {
      const header = this.$store.state.prismicHeader || {};
      const megaMenuLinks = header?.mega_menu_links || [];

      const items = megaMenuLinks
        .filter(item => item.link && item.link._meta)
        .map(item => {
          // Extract text properly from Prismic rich text field
          const label = item.link_label || [];
          const name = label
            .map(block => block?.text || "")
            .join(" ")
            .trim()
            .replace(/\s+/g, " "); // Normalize multiple spaces to single space

          return {
            name,
            url: this.$prismic.asLink(item.link),
          };
        })
        .filter(item => item.name); // Remove items with empty names

      return items;
    },

    additionalScripts() {
      const navScript = this.siteNavigationSchemaScript;
      const orgScripts = getHomepageOrganizationScript(
        this.$store,
        this.$prismic,
        this.$config.appEndPoint
      );
      return [...(navScript ? [navScript] : []), ...orgScripts];
    },
  },
};
